// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"b3dfb13f","323":"80d18b4c","332":"fe496492","375":"3b3ecdda","421":"234c13a4","451":"86eac0d8","453":"213d4958","496":"ff273535","589":"2d0520b0","591":"23593759","619":"c231a2d6","685":"c5710908","773":"33645e44","857":"c69db1ee","959":"dbeec30e"}[chunkId] + ".chunk.js";
};